<template>
	<div>
		<img style="width: 100%; " src="../assets/banner/login.jpg" />
		
		<div class="login">
			<div class="title">
				로그인
			</div>
			<div class="summary">
				로그인을 하신 후에 서비스를 이용해 주세요.
			</div>
			<div style="display: flex;justify-content: center; margin-top: 30px;">
				<el-form ref="form" :model="form" label-position="top" class="large-form" style="width: 400px;" autocomplete="on" @submit.native.prevent="onSubmit">
				  <el-form-item label="아이디 입력">
				    <el-input v-model="form.username" style="width: 100%;" name="username" autocomplete="username"></el-input>
				  </el-form-item>
				  <el-form-item label="비밀번호 입력">
				    <el-input type="password" v-model="form.password" style="width: 100%;" name="password" autocomplete="current-password" @keyup.enter.native="onSubmit"></el-input>
				  </el-form-item>
				 
				  <el-form-item style="margin-top: -10px; margin-bottom: 10px;">
				    <el-checkbox v-model="saveId">아이디 저장</el-checkbox>
				  </el-form-item>
				 
				  <el-form-item style="margin-top: 10px;">
				    <el-button type="primary" native-type="submit" style="width: 100%; height: 50px; font-size: 18px; font-weight: bold; background-color: #F7941D; border: none;">로그인</el-button>
				  </el-form-item>
				  <el-form-item style="margin-top: -10px;">
				    <div @click="loginWithKakao" style="width: 100%; height: 50px; border-radius: 4px; background-color: #FEE500; color: #191919; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 16px; font-weight: bold; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
				      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style="width: 20px; height: 20px; margin-right: 8px;">
				        <path d="M12 3c-5.52 0-10 3.48-10 7.78 0 2.76 1.83 5.17 4.58 6.57l-1.16 4.29c-.08.31.11.61.42.61.16 0 .31-.06.41-.16l5.05-3.34c.88.11 1.79.17 2.7.17 5.52 0 10-3.48 10-7.78s-4.48-7.78-10-7.78z"/>
				      </svg>
				      카카오 로그인
				    </div>
				  </el-form-item>
				</el-form>
						
			</div>
			
			<div style="text-align: center;">
				<router-link class="link" to="/">
					아이디/비밀번호 찾기
				</router-link>	
				<div class="register-tip">
					아직 고로켓고 회원이 아니세요? 
				</div>
				<div class="register" @click="onRegister">
					회원가입
				</div>	
			</div>
			
			
			<div class="login-info">
				<ul>
					<el-row>
						<el-col :xs="24" :sm="8">
							<li>
							
								<div class="img-wrapper">
									<img src="../assets/icon/login-info1.png" loading="lazy" alt="고객 통합센터">
								</div>
					
								<div>
									<strong style="color: #007aff;font-size: 1rem;">고객 통합센터</strong>
									<p style="font-size: 0.9375rem;">한, 중 양국에서<br>운영하는<br>전문 상담 서비스</p>
								</div>
								
							
								
								

							</li>
						</el-col>
						<el-col :xs="24" :sm="8">
							<li>
				
								<div class="img-wrapper">
									<img src="../assets/icon/login-info3.png" loading="lazy" alt="회원수 압도적 1위">
								</div>
								<strong style="color: #007aff;font-size: 1rem;">회원수 압도적 1위</strong>
								<p tyle="font-size: 0.9375rem;">중국 전문배대지<br>압도적 회원 수 1위<br>지금 체험해 보세요.</p>
							</li>
						</el-col>
						<el-col :xs="24" :sm="8">
							<li>
				
								
								<div class="img-wrapper">
									<img src="../assets/icon/login-info2.png" loading="lazy" alt="안심 보장제">
								</div>
								<strong style="color: #007aff;font-size: 1rem;">안심 보장제</strong>
								<p tyle="font-size: 0.9375rem;">분실, 파손, 실측 중량 차이<br>걱정 없이 안심 구매<br>안심배송</p>
							</li>
						</el-col>
					</el-row>
					
					
					
				</ul>
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	import request from '@/utils/request';
	import { mapActions } from 'vuex';
	export default {

		data() {
			return {
				form: {
				  username: '',
				  password: '',
				},
				saveId: false,
		
				
			};
		},
		mounted() {
			const savedId = localStorage.getItem('savedUsername');
			if (savedId) {
				this.form.username = savedId;
				this.saveId = true;
			}
		},
		
	  methods: {
		...mapActions(['login', 'logout']),
		onSubmit() {
			
			console.log(this.form,'submit!');
			if(!this.form.username ||!this.form.password){
				alert("아이디와 비밀번호를 필수로 입력해주세요.")
				return
			}
			// 登录成功后，后台返回 token
			request.post('/User/login', 
				this.form
			  // username: 'admin1',
			  // password: '2222'
			).then(response => {
				
				if(response.code ==1){
					// 保存 ID 逻辑
					if (this.saveId) {
						localStorage.setItem('savedUsername', this.form.username);
					} else {
						localStorage.removeItem('savedUsername');
					}

					const userinfo = response.data.userinfo; // 假设后台返回 { token: "xxx" }
					console.log(userinfo,33)
					try {
						this.login({ //await 
						  token: userinfo.token,
						  nickname: userinfo.nickname,
						  user_id: userinfo.id,
						});
						console.log('登录成功！');
						alert("로그인 성공")
					  } catch (error) {
						console.error('登录失败:', error);
					  }
					// localStorage.setItem('token', userinfo.token); // 存储 token
					// localStorage.setItem('nickname', userinfo.nickname);
					if(localStorage.getItem('redirectPath')){
						this.$router.replace(localStorage.getItem('redirectPath'))
					}else{
						this.$router.replace('/');
					}
					
				}else{
					alert(response.msg)
					return
				}
		
			});
				
		
			
			
		},
		onRegister(){
			 this.$router.push('/register');
		},
		loginWithKakao() {
			const redirectUri = window.location.origin + "/kakao-callback";
			request.post('/User/getKakaoConfig')
				.then(res => {
					if (res.code === 1) {
						const clientId = res.data.client_id;
						const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code`;
						window.location.href = kakaoAuthUrl;
					} else {
						alert(res.msg || 'Kakao 설정을 가져올 수 없습니다.');
					}
				})
				.catch(err => {
					console.error(err);
					alert('네트워크 오류가发生했습니다.');
				});
		}
	
	  },
	  
	  
	}
</script>

<style scoped>

	.title{
		font-size: 45px;
		text-align: center;
		font-weight: bold;
		margin: 10px 0 30px;
	}
	.summary{
		display: block;
		text-align: center;
		font-size: 20px;
		margin: 15px 0 20px;
		font-weight: normal;
	}
	.link{
		color: #333;text-decoration: none;font-size:15px;
	}
	.register-tip{
		font-weight: 500;
		font-size: 15px;
		margin:15px 0 12px
	}
	.register{
		width: 92px;
		height: 42px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #d6e7f9;
		border-radius: 54px;
		color: #274a80;
		font-size: 15px;
		text-decoration: none;
		font-weight: 600;
		margin: 0 auto;
	}
	.register:hover {
	    cursor: pointer;
	}
	.login-info{
		margin-top: 80px;
	}
	.login-info ul{
		list-style-type: none;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		margin: 0 auto;
	}
	.login-info ul li{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		width: 200px;
	}
	.img-wrapper{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 70px;
		height: 70px;
		border-radius: 50%;
		background: #f2f2f2;
		margin-bottom:10px;
	}
	
	@media (min-width:800px) {
		.login{
			width: 800px;
			margin: 2.5rem auto;

		}
	}
	 @media (max-width: 768px) {
		 .login-info{
			 
			 margin: 40px auto 0;
			 padding: 0 auto;
			 width: 200px;
		 }
/* 		 .login-info ul{
			list-style: none;
			padding: 0;
			margin: 0 auto;
			width: 300px;
		 }
		 .login-info ul li{
			display: flex;
			align-items: center;
			gap: 10px;
			margin-bottom: 20px;
		 }
		 .img-wrapper{
			display: flex;
			align-items: center;
			justify-content: center;
			width: 70px;
			height: 70px;
			border-radius: 50%;
			background: #f2f2f2;
		 } */
		 
	 }
</style>